import { PatientVitalControllerApi, PatientVitalRequest } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const usePatientVitalsCreate = () =>
  useMutationWithLoading(
    async (params: {
      patientVitalRequest: PatientVitalRequest;
      xTENANTID?: string;
    }) =>
      new PatientVitalControllerApi(getConfigObject()).createPatientVital(
        params?.patientVitalRequest,
        params.xTENANTID
      )
  );
